import api from '../../services/api';
import { Cuota } from '../cuentacorriente/ctaCorrienteAPI';

export interface Expirations {
  vencimientos: Vencimiento[];
  paginacion: Paginacion;
}

export interface Paginacion {
  page: number;
  total: number;
}

export interface VencimientoVencido {
  imponible: ReducedImponible;
  recurso: ReducedResource;
  tipo: 'vencido';
  vencimiento: string;
  cuotas: Cuota[];
  monto_original: number;
  intereses: number;
  multa: number;
  planes: boolean; // Soporte creación de planes
}

export interface VencimientoNoVencido {
  imponible: ReducedImponible;
  recurso: ReducedResource;
  tipo: 'no_vencido';
  vencimiento?: string;
  cuota: Cuota;
  monto_original: number;
  planes: boolean; // Soporte creación de planes
}

export type Vencimiento = VencimientoVencido | VencimientoNoVencido;

export interface ReducedImponible {
  tipo: string;
  imponible: string;
  referencia: string;
}

export interface ReducedResource {
  numero: string;
  descripcion: string;
}

async function getExpirations(pagination: number) {
  const response = await api<Expirations>(
    'GET',
    `suscripciones/vencimientos/?page=${pagination}`
  );

  return response;
}

const expirationsAPI = {
  getExpirations,
};

export default expirationsAPI;
